<template>
	<BaseCard
		:is-editable="!isProcessFinished"
		:title="$t('process_number').toString()"
		@clickEdit="$router.push({ name: 'damagecases.edit.transactionKey' })"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<template #icons>
			<div class="flex items-center">
				<font-awesome-icon icon="exclamation-triangle" v-if="isEmptyReferenceNumber" class="text-red-700" />
			</div>
		</template>
		<BaseCardRow :value="damageCase.imdNetId" :label="$t('imd_connect')" />
		<BaseCardRow
			v-if="damageCase.damageAssessor && damageCase.process_type !== 'order_documentation'"
			:value="damageCase.damageAssessorReferenceNumber"
			:label="damageAssessorLabel"
			:missing-value="damageAssessorReferenceNumberMissingLabel"
		/>
		<BaseCardRow
			:value="damageCase.lawyerOfficeReferenceNumber"
			:label="$t('lawyer')"
			:missing-value="'-'"
			v-if="damageCase.lawyerOffice && damageCase.process_type !== 'order_documentation'"
		/>
		<BaseCardRow
			:value="damageCase.repairShopReferenceNumber"
			:label="$store.getters.repairShopLabel"
			:missing-value="isEmptyRepairShopReferenceNumber ? $t('enter_process_number') : '-'"
		/>
	</BaseCard>
</template>
<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'ReferenceNumberCard',
	components: { BaseCard, BaseCardRow },
	mixins: [Authentication],
	props: {
		damageCase: {},
		isProcessFinished: {},
		isToggleOpen: { type: Boolean, default: true },
	},
	computed: {
		damageAssessorLabel() {
			// if (!this.$store.getters.isProcessLiability) return this.$t('expertise_number');
			return this.$t('damage_assessor');
		},
		damageAssessorReferenceNumberMissingLabel() {
			if (!this.damageCase.damageAssessor.system_assessor) return this.$t('enter_expertise_number');
			else if (this.isEmptyDamageAssessorReferenceNumber) return this.$t('enter_process_number');
			return '-';
		},
		isEmptyLawyerOfficeReferenceNumber() {
			return this.isUserAllowedInLevel3 && !this.damageCase.lawyerOfficeReferenceNumber;
		},
		isEmptyDamageAssessorReferenceNumber() {
			return this.isUserAllowedInLevel2 && !this.damageCase.damageAssessorReferenceNumber;
		},
		isEmptyRepairShopReferenceNumber() {
			return this.isUserAllowedInLevel5or6 && !this.damageCase.repairShopReferenceNumber;
		},
		isEmptyReferenceNumber() {
			return (
				(this.isUserAllowedInLevel2 && !this.damageCase.damageAssessorReferenceNumber) ||
				(this.isUserAllowedInLevel3 && !this.damageCase.lawyerOfficeReferenceNumber) ||
				(this.isUserAllowedInLevel5or6 && !this.damageCase.repairShopReferenceNumber)
			);
		},
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
	},
};
</script>
